import * as reducers from './ducks';
import MessageHeader from './views/components/messageHeader';

export default { reducers, headerItems: [MessageHeader] };
